import { useTranslation } from 'react-i18next';
import { resources } from '../../../resources/resources';

export default function PrivacyInfo() {
  const { t: translate } = useTranslation();
  return (
    <div className="info-box product-privacy-box">
      <div className="info-icon">
        <span></span>
      </div>
      <div className="info-text">
        {translate(resources.products.privacyInfoMessage)}
      </div>
    </div>
  );
}
